import { cloneDeep } from 'lodash'

const missingAudioClip = (x) => {
  return typeof x.audioClip === 'undefined'
}

const defaultAudioClip = (x) => {
  return {
    ...x,
    audioClip: null,
  }
}

export default function migrate(data) {
  const hasCardsMissingAudioClips = data.cards && data.cards.some(missingAudioClip)
  const hasPlacesMissingAudioClips = data.places && data.places.some(missingAudioClip)
  const hasNotesMissingAudioClips = data.notes && data.notes.some(missingAudioClip)
  const hasCharactersMissingAudioClips = data.characters && data.characters.some(missingAudioClip)

  if (
    hasCardsMissingAudioClips ||
    hasPlacesMissingAudioClips ||
    hasNotesMissingAudioClips ||
    hasCharactersMissingAudioClips
  ) {
    const newData = cloneDeep(data)
    if (hasCardsMissingAudioClips) {
      newData.cards = newData.cards.map(defaultAudioClip)
    }
    if (hasPlacesMissingAudioClips) {
      newData.places = newData.places.map(defaultAudioClip)
    }
    if (hasNotesMissingAudioClips) {
      newData.notes = newData.notes.map(defaultAudioClip)
    }
    if (hasCharactersMissingAudioClips) {
      newData.characters = newData.characters.map(defaultAudioClip)
    }
    return newData
  } else {
    return data
  }
}
